<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12" class="mb-8">
				<v-tabs>
					<v-tab>{{ $t('tabs.basicInfo') }}</v-tab>
					<v-tab-item>
						<v-card flat outlined>
							<v-card-text>
								<v-row>
									<v-flex xs12 md4 lg4>
										<v-card-title class="pa-2">{{
											$t('titles.contractInformations')
										}}</v-card-title>
									</v-flex>
									<v-flex class="d-flex justify-end">
										<v-btn
											v-if="inEditMode"
											class="ml-2 mr-2"
											color="primary"
											@click="saveClick(null)"
										>
											<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
										</v-btn>
										<v-btn
											v-if="!inEditMode"
											class="ml-2 mr-2"
											color="primary"
											@click="editClick()"
										>
											<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
										</v-btn>
										<v-btn class="mr-2" color="basicButton" @click="backClick">
											<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
										</v-btn>
									</v-flex>
								</v-row>
								<v-row wrap>
									<v-flex lg6 xs12 sm12 class="pt-0">
										<v-col cols="12" v-if="$route.params.id != 0">
											<InputField
												:disabled="true"
												v-model="contract.contract_number"
												:label="'* ' + $t('fields.contractNumber')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:disabled="true"
												v-model="contract.author.full_name"
												:label="'* ' + $t('fields.created')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<DatePicker
												:readonly="!inEditMode"
												v-model="contract.start_date"
												:errorBorder="!contractValidation.start_date"
												:date-label="'* ' + $t('fields.startDate')"
											></DatePicker>
										</v-col>
										<v-col cols="12">
											<DatePicker
												:readonly="!inEditMode"
												v-model="contract.end_date"
												:errorBorder="!contractValidation.end_date"
												:date-label="'* ' + $t('fields.endDate')"
											></DatePicker>
										</v-col>
									</v-flex>
									<v-flex lg6 xs12 sm12 class="pt-0">
										<v-col cols="12" v-if="$route.params.id == 0">
											<DropdownMultiple
												:readonly="!inEditMode"
												v-model="contract.teacher_ids"
												:ajax="true"
												:data="'teachers'"
												:errorBorder="!teachersValidation"
												:label="'* ' + $t('fields.teachers')"
											></DropdownMultiple>
										</v-col>
										<v-col cols="12" v-else>
											<Dropdown
												:readonly="!inEditMode"
												v-model="contract.teacher_id"
												:ajax="true"
												:data="'teachers'"
												:errorBorder="!contractValidation.teacher_id"
												:label="'* ' + $t('fields.teacher')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="contract.contract_type_id"
												:ajax="true"
												:data="'contract-types'"
												:errorBorder="!contractValidation.contract_type_id"
												:label="'* ' + $t('fields.contractType')"
											></Dropdown>
										</v-col>
									</v-flex>
								</v-row>
								<div :class="['text-subtitle-1', 'pa-2']">{{ $t('titles.hourlyRates') }}</div>
								<v-row wrap>
									<v-flex lg6 xs12 sm12 class="pb-2">
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="contract.t1"
												:precision="2"
												:errorBorder="!contractValidation.t1"
												:label="'* ' + $t('fields.t1')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												:rows="2"
												v-model="contract.program_t1"
												:errorBorder="!contractValidation.program_t1"
												:label="'* ' + $t('fields.programT1')"
											></TextArea>
										</v-col>
									</v-flex>
									<v-flex lg6 xs12 sm12 class="pb-2">
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="contract.t2"
												:precision="2"
												:errorBorder="!contractValidation.t2"
												:label="$t('fields.t2')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												:rows="2"
												v-model="contract.program_t2"
												:errorBorder="!contractValidation.program_t2"
												:label="$t('fields.programT2')"
											></TextArea>
										</v-col>
									</v-flex>
									<v-flex lg6 xs12 sm12 class="pb-2">
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												:rows="2"
												v-model="contract.t3"
												:precision="2"
												:errorBorder="!contractValidation.t3"
												:label="$t('fields.t3')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												:rows="2"
												v-model="contract.program_t3"
												:errorBorder="!contractValidation.program_t3"
												:label="$t('fields.programT3')"
											></TextArea>
										</v-col>
									</v-flex>
									<v-flex lg6 xs12 sm12 class="pb-2">
										<v-col cols="12">
											<NumberField
												:readonly="!inEditMode"
												v-model="contract.t4"
												:precision="2"
												:errorBorder="!contractValidation.t4"
												:label="$t('fields.t4')"
											></NumberField>
										</v-col>
										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												:rows="2"
												v-model="contract.program_t4"
												:errorBorder="!contractValidation.program_t4"
												:label="$t('fields.programT4')"
											></TextArea>
										</v-col>
									</v-flex>

									<v-col cols="12" v-if="$route.params.id != 0 && inEditMode">
										<Upload
											:readonly="!inEditMode"
											:label="$t('fields.signedContractUpload')"
											v-model="contract.uploaded_file"
											:errorBorder="!contractValidation.uploaded_file"
										></Upload>
									</v-col>
									<v-col>
										<v-btn
											v-if="!inEditMode"
											class="ml-2 mr-2"
											color="primary"
											@click="generateContractDocument()"
										>
											<v-icon small>fa-file-word</v-icon>&nbsp;{{
												$t('buttons.generateContract')
											}}
										</v-btn>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item> </v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import Contract from '../../../models/Contract';
import NumberField from '../../trinkets/NumberField';
import Dropdown from '../../trinkets/Dropdown';
import DropdownMultiple from '../../trinkets/DropdownMultiple';
import DatePicker from '../../trinkets/DatePicker';
import TextArea from '../../trinkets/TextArea';
import Upload from '../../trinkets/Upload';

export default {
	name: 'Contract',
	components: { InputField, Upload, NumberField, DatePicker, Dropdown, DropdownMultiple, TextArea },
	data: function () {
		return {
			contract: new Contract({ id: this.$route.params.id }),
			contractValidation: new Contract({}, true),
			teachersValidation: true,
			initialLoad: false,
			inEditMode: false,
			lockKey: 'contract',
			lockTimer: null,
		};
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.contract.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.contract.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},
		backClick() {
			this.$router.go(-1);
		},
		generateContractDocument() {
			var vm = this;
			this.$APICall(
				'get',
				'docx/' + this.contract.id,
				{},
				(data, success) => {
					if (success) {
						window.open(data.link);
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},

		saveClick(after = null) {
			let success = true;
			let errorMessages = '';

			if (!this.contract.start_date) {
				success = false;
				this.contractValidation.start_date = false;
			} else {
				this.contractValidation.start_date = true;
			}

			if (!this.contract.end_date) {
				success = false;
				this.contractValidation.end_date = false;
			} else {
				this.contractValidation.end_date = true;
			}

			if (this.$route.params.id == 0) {
				if (this.contract.teacher_ids.length <= 0) {
					success = false;
					this.teachersValidation = false;
				} else {
					this.teachersValidation = true;
				}
			} else {
				if (!this.contract.teacher_id) {
					success = false;
					this.contractValidation.teacher_id = false;
				} else {
					this.contractValidation.teacher_id = true;
				}
			}

			if (!this.contract.contract_type_id) {
				success = false;
				this.contractValidation.contract_type_id = false;
			} else {
				this.contractValidation.contract_type_id = true;
			}

			if (this.contract.program_t1 == null || this.contract.program_t1 == '') {
				success = false;
				this.contractValidation.program_t1 = false;
			} else {
				if (this.contract.program_t1.length > 200) {
					this.contractValidation.program_t1 = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.programT1'))
							.replace('%length%', '200') + '<br />';
				} else {
					this.contractValidation.program_t1 = true;
				}
			}

			if (
				this.contract.program_t2 !== null &&
				this.contract.program_t2 !== '' &&
				this.contract.program_t2.length > 200
			) {
				success = false;
				this.contractValidation.program_t2 = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.programT2'))
						.replace('%length%', '200') + '<br />';
			} else {
				this.contractValidation.program_t2 = true;
			}

			if (
				this.contract.program_t3 !== null &&
				this.contract.program_t3 !== '' &&
				this.contract.program_t3.length > 200
			) {
				success = false;
				this.contractValidation.program_t3 = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.programT3'))
						.replace('%length%', '200') + '<br />';
			} else {
				this.contractValidation.program_t3 = true;
			}

			if (
				this.contract.program_t4 !== null &&
				this.contract.program_t4 !== '' &&
				this.contract.program_t4.length > 200
			) {
				success = false;
				this.contractValidation.program_t4 = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.programT4'))
						.replace('%length%', '200') + '<br />';
			} else {
				this.contractValidation.program_t4 = true;
			}

			if (this.contract.t1 == 0) {
				success = false;
				this.contractValidation.t1 = false;
			} else {
				if (this.contract.t1 < 0.01 || this.contract.t1 > 100) {
					this.contractValidation.t1 = false;
					errorMessages +=
						this.$t('alerts.valueError')
							.replace('%field%', this.$t('fields.t1'))
							.replace('%min%', '0.01')
							.replace('%max%', '100') + '<br />';
				} else {
					this.contractValidation.t1 = true;
				}
			}

			if (this.contract.t2 > 0 && (this.contract.t2 < 0.01 || this.contract.t2 > 100)) {
				this.contractValidation.t2 = false;
				errorMessages +=
					this.$t('alerts.valueError')
						.replace('%field%', this.$t('fields.t2'))
						.replace('%min%', '0.01')
						.replace('%max%', '100') + '<br />';
			} else {
				this.contractValidation.t2 = true;
			}

			if (this.contract.t3 > 0 && (this.contract.t3 < 0.01 || this.contract.t3 > 100)) {
				this.contractValidation.t3 = false;
				errorMessages +=
					this.$t('alerts.valueError')
						.replace('%field%', this.$t('fields.t3'))
						.replace('%min%', '0.01')
						.replace('%max%', '100') + '<br />';
			} else {
				this.contractValidation.t3 = true;
			}

			if (this.contract.t4 > 0 && (this.contract.t4 < 0.01 || this.contract.t4 > 100)) {
				this.contractValidation.t4 = false;
				errorMessages +=
					this.$t('alerts.valueError')
						.replace('%field%', this.$t('fields.t4'))
						.replace('%min%', '0.01')
						.replace('%max%', '100') + '<br />';
			} else {
				this.contractValidation.t4 = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.contract.id != 0) {
					action = 'put';
					addition = '/' + vm.contract.id;
				}
				if (this.$route.params.id == 0) {
					this.contract.author_id = this.$myStore.state.user.id;
				}

				if (this.contract.program_t3 === '') {
					this.contract.program_t3 = null;
				}
				if (this.contract.program_t4 === '') {
					this.contract.program_t4 = null;
				}

				this.$APICall(action, 'contracts' + addition, this.contract, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.contract.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
							window.open(data.link);
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.contract.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.contract.id);
			next(true);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		if (this.$myStore.state.user.user_role_id == 2) {
			this.$router.replace('/candidates');
		}
		if (this.$route.params.id == 0) {
			this.contract.author.full_name =
				this.$myStore.state.user.first_name + ' ' + this.$myStore.state.user.last_name;
		}
		let vm = this;
		if (this.contract.id != 0) {
			this.$APICall('get', 'contracts/' + this.contract.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.contract = usableData;
					vm.$myStore.commit('setBreadcrumbs', [
						{
							text: vm.$t('modules.contracts'),
							href: '/#/contracts',
							disabled: false,
						},
						{
							text:
								vm.contract.contract_type_name +
								' (' +
								vm.contract.contract_number +
								') - ' +
								vm.contract.teacher.full_name,
							href: '/#/contracts/' + vm.contract.id,
							disabled: true,
						},
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.contracts'),
					href: '/#/contracts',
					disabled: false,
				},
				{
					text: this.$t('modules.newContract'),
					href: '/#/contracts/0',
					disabled: true,
				},
			]);
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped></style>
